// Dependencies
import styled from 'styled-components'
import { pageGutter } from 'styles/gutter'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #eceeee;

  ${pageGutter}
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 24px;
  padding-inline: 24px;
  padding-block: 40px;

  @media (min-width: 768px) {
    padding-inline: 0;
    gap: 40px;
  }

  @media (min-width: 1366px) {
    padding-block: 80px;
  }
`

export const FaqSectionTitle = styled.h4`
  font-family: 'Source Sans 3', sans-serif;
  font-size: 32px;
  font-weight: 700;
  line-height: 38px;
  color: #25272d;
`

export const FaqContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: center;
  }
`

export const Separator = styled.div`
  display: block;
  width: 100%;
  height: 1px;
  background-color: #ced0dd;
`
